export default {
    header: {
        home_page: "Anasayfa",
        about_page: "Hakkımızda",
        ombox_page: "Ombox",
        contact_page: "İletişim",
    },
    footer: {
        title: "© 2020 Powered By Renet Teknoloji",
        cerez_politikasi: 'Çerez Politikası',
        aydinlatma_metni: 'Aydınlatma Metni',
        kullanim_kosullari: 'Kullanım Koşulları'
    },
    home: {
        title: 'Elektrik Dağıtım Sektöründeki Yeri',
        desc1: 'Dağıtım şirketlerine özel çözümler üreten, yazılım ve donanım konularında uzman, entegratör bir teknoloji firmasıdır. Elektrik dağıtım sektörünün özelleştirilmesi ile başlayan yeniden yapılanma sürecinin ilk günlerinden bu yana sektörün içinde yer almaktadır.',
        desc2: 'Müşteri memnuniyetinden saha ekiplerinin verimliliğinin artırılmasına kadar birçok başarılı projeye imza atan RENET ekibi, şirketlerce kullanılan tüm yazılım ve sistemlerin birbiriyle entegrasyonu alanında da derin deneyime sahiptir.'
    }
}